<div class="slider">
  <div class="text">
    <span>{{minRange}}</span>
    <span>{{maxRange}}</span>
  </div>
  <p-slider [styleClass]="classesToAdd" [(ngModel)]="rangeValue[0]" [min]="minRange" [max]="maxRange"
    [disabled]="disabled" [orientation]="orientation" [animate]="animate"
    (ngModelChange)="sliderValue($event)"></p-slider>
  <div class="value" *ngIf="!view">Selected Value : <span>{{rangeValue[0]}}</span></div>
</div>